import React, { useRef } from "react";
import { Content, ContentBox, TextBox, Wrapper } from "./style";
import { useScrollFadeIn } from "hooks/useScrollFadeIn";
const Com5 = ({ t }) => {
  const ref1 = useRef();
  const ref2 = useRef();
  const ref3 = useRef();

  useScrollFadeIn(ref1, ref2, ref3);
  return (
    <Wrapper>
      <TextBox>
        <div>
          <span>{t("5-1")}</span>
        </div>
        <div>
          <span>{t("5-2")}</span>
        </div>
      </TextBox>
      <Content>
        <ContentBox ref={ref1} className="fade-in">
          <div>
            <span>{t("5-3")}</span>
          </div>
          <div>
            <span>{t("5-4")}</span>
            <span>{t("5-5")}</span>
          </div>
        </ContentBox>
        <ContentBox ref={ref2} className="fade-in">
          <div>
            <span>{t("5-6")}</span>
          </div>
          <div>
            <span>{t("5-7")}</span>
            <span>{t("5-8")}</span>
          </div>
        </ContentBox>
        <ContentBox ref={ref3} className="fade-in">
          <div>
            <span>{t("5-9")}</span>
          </div>
          <div>
            <div>{t("5-10")}</div>
            <div>{t("5-11")}</div>
          </div>
        </ContentBox>
      </Content>
    </Wrapper>
  );
};

export default Com5;
